import { GenericValue } from 'hisng';

import { ResearchPartnerSimple } from 'app/fs/res/common/model/researchPartner/researchPartner';
import { Publication } from 'app/fs/res/publication/model/publication';
import { ResearchInfrastructure } from './research-infrastructure';
import { Employment } from 'app/fs/res/employment/model/employment';

export class ResearchInfrastructureUsage {
    id: number;
    researchInfrastructure: ResearchInfrastructure;
    researchInfrastructureUsageType: GenericValue;
    usageYear: number;
    usageAmount: number;

    constructor( usageYear?: number ) {
        this.usageYear = usageYear;
    }
}

export class ResearchInfrastructureOrganisation {
    id: number;
    // researchInfrastructure: ResearchInfrastructure;
    orgunit: GenericValue = new GenericValue();
    researchPartner: ResearchPartnerSimple;
    isCoordinator: boolean;

    constructor( orgunit?: GenericValue, researchPartner?: ResearchPartnerSimple, isCoordinator?: boolean ) {
        this.orgunit = orgunit;
        this.researchPartner = researchPartner;
        this.isCoordinator = isCoordinator;
    }
}

export class ResearchInfrastructureEmployment {
    id: number;
    // researchInfrastructure: ResearchInfrastructure;
    employment: Employment;
    fullTimePercentage: number;
    validFrom: string | Date;
    validTo: string | Date;
}

export class ResearchInfrastructurePublication {
    id: number;
    researchInfrastructure: ResearchInfrastructure;
    publication: Publication;
}
